import { createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';

import { CachedUserDetails } from '@store';

import { AppState } from '../app.state';

import { EventsState } from './events.state';
import { ViEvent } from '@vi-iot/client/index';

export namespace EventsSelectors {
  export const events = (state: AppState): EventsState => state.events;

  export function getState(): MemoizedSelector<
    AppState,
    EventsState,
    DefaultProjectorFn<EventsState>
  > {
    return createSelector(events, (state: EventsState) => state);
  }

  export function getCursor(): MemoizedSelector<AppState, string, DefaultProjectorFn<string>> {
    return createSelector(events, (state: EventsState) => state.cursor);
  }

  export function getEvents(): MemoizedSelector<
    AppState,
    ViEvent[],
    DefaultProjectorFn<ViEvent[]>
  > {
    return createSelector(events, (state: EventsState) => state.events);
  }

  export function getFilters(): MemoizedSelector<AppState, string[], DefaultProjectorFn<string[]>> {
    return createSelector(events, (state: EventsState) => state.filters);
  }

  export function getDateFilter(): MemoizedSelector<AppState, string, DefaultProjectorFn<string>> {
    return createSelector(events, (state: EventsState) => state.dateFilter);
  }

  export function getCachedUsername(
    uuid: string
  ): MemoizedSelector<AppState, string, DefaultProjectorFn<string>> {
    return createSelector(events, (state: EventsState) => {
      const matchingUser = state.cachedUsers.find((user) => user.uuid === uuid);

      return matchingUser?.username;
    });
  }

  export function getCachedUser(
    uuid: string
  ): MemoizedSelector<AppState, CachedUserDetails, DefaultProjectorFn<CachedUserDetails>> {
    return createSelector(events, (state: EventsState) => {
      const matchingUser = state.cachedUsers.find((user) => user.uuid === uuid);

      return matchingUser;
    });
  }

  export function getCachedUsers(): MemoizedSelector<
    AppState,
    CachedUserDetails[],
    DefaultProjectorFn<CachedUserDetails[]>
  > {
    return createSelector(events, (state: EventsState) => state.cachedUsers);
  }

  export const selectIsDownloadFileBeingGenerated = createSelector(
    events,
    (state: EventsState): boolean => state.downloadGeneration.loading
  );
}
